// src/App.js
import React from "react";
import Landing from "./landing/pages/landing";

// ---- MUI theme setup ----
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/open-sans/400.css"; // optional secondary font

// Create a custom theme
const theme = createTheme({
  typography: {
    fontFamily: '"Roboto", "Open Sans", "Helvetica", "Arial", sans-serif',
    h1: { fontFamily: '"Roboto", sans-serif', fontWeight: 700 },
    h2: { fontFamily: '"Roboto", sans-serif', fontWeight: 700 },
    h3: { fontFamily: '"Roboto", sans-serif', fontWeight: 700 },
    h4: { fontFamily: '"Roboto", sans-serif', fontWeight: 700 },
    body1: { fontFamily: '"Open Sans", sans-serif' },
    body2: { fontFamily: '"Open Sans", sans-serif' },
  },
  palette: {
    primary: {
      main: "#16a1d8",
    },
    background: {
      default: "#1a1a1a",
      paper: "#2c2c2c",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* resets and applies theme background */}
      <Landing />
    </ThemeProvider>
  );
}

export default App;
